import React from 'react';
import { siteConfig } from '../config/siteConfig';
export function Header() {
  return <header className="absolute top-[2px] z-50 w-full h-[80px] bg-brand-navy/50 backdrop-blur-md border-b border-white/10 flex items-center justify-center" data-id="element-75">
      <div className="w-full max-w-7xl px-4 md:px-8 flex items-center justify-between" data-id="element-76">
        <img src={siteConfig.brand.logoWhite} alt={siteConfig.brand.name} className="h-8 w-auto" data-id="element-77" />
        <a href="#lead-form" className="text-sm font-bold text-brand-gold hover:text-white transition-colors tracking-wide uppercase" data-id="element-78">
          Book a Call
        </a>
      </div>
    </header>;
}